import type { SubscriptionOptions } from '@reduxjs/toolkit/query'

import Archived from 'assets/image/icons/svg/icons/archived.svg'
import InMail from 'assets/image/icons/svg/icons/inmail.svg'
import MyConnections from 'assets/image/icons/svg/icons/myConnections.svg'
import Spam from 'assets/image/icons/svg/icons/spam.svg'
import Starred from 'assets/image/icons/svg/icons/starred.svg'
import Unread from 'assets/image/icons/svg/icons/unread.svg'
import { CONSTS } from 'config/objectConst'

import type { Filter } from '../model/types'

const isDev = import.meta.env.DEV

interface FilterItem {
	icon: string
	key: Filter
	title: string
}

const FILTERS: FilterItem[] = [
	{ icon: Unread, key: 'unread', title: 'Unread' },
	{ icon: Starred, key: 'starred', title: 'Starred' },
	{ icon: InMail, key: 'in-mail', title: 'InMail' },
	{ icon: MyConnections, key: 'my-connections', title: 'My connections' },
	{ icon: Archived, key: 'archive', title: 'Archived' },
	{ icon: Spam, key: 'spam', title: 'Spam' }
]

const INTERVAL_OPTIONS = {
	pollingInterval: isDev
		? undefined
		: CONSTS.MESSAGING.REFRESH_INTERVAL_IN_SECONDS * 1000,
	skipPollingIfUnfocused: true
}

interface Tab {
	label: string
	value: Filter
}

const TABS: Tab[] = [
	{
		label: 'Focused',
		value: 'focused'
	},
	{
		label: 'Other',
		value: 'other'
	}
]

const PULLING_OPTIONS: SubscriptionOptions = {
	pollingInterval: CONSTS.MESSAGING.REFRESH_INTERVAL_IN_SECONDS * 1_000,
	refetchOnReconnect: true,
	skipPollingIfUnfocused: true
}

export { FILTERS, INTERVAL_OPTIONS, PULLING_OPTIONS, TABS }
